import { render, staticRenderFns } from "./Procurement_fee.vue?vue&type=template&id=652c45c0&scoped=true"
import script from "./Procurement_fee.vue?vue&type=script&lang=js"
export * from "./Procurement_fee.vue?vue&type=script&lang=js"
import style0 from "./Procurement_fee.vue?vue&type=style&index=0&id=652c45c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c45c0",
  null
  
)

export default component.exports